import { BaseClient } from 'src/common-services/clients/base-client'
import { AMBrand } from 'src/common-services/types/alphamap'

export class BrandsClient extends BaseClient {
  getAlphamapBrands(): Promise<AMBrand[]> {
    return this.call<AMBrand[]>('/brands/alphamap-brands', 'GET')
  }

  getAlphamapBrandByBrandId(id: string): Promise<AMBrand> {
    return this.call<AMBrand>(`/brands/alphamap/${id}`, 'GET')
  }
}
